<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        (click)="createTimeEntry()"
        [disabled]="!inputsValid()"
        *ngIf="!workDayId"
        >Arbeitszeit anlegen</ion-button
      >
      <ion-button
        (click)="updateTimeEntry()"
        [disabled]="!inputsValid()"
        *ngIf="workDayId"
        >Arbeitszeit aktualisieren</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div class="select-form" *ngIf="state.userHasMinType(1)">
      <lib-user-picker
        *ngIf="!workDayId"
        [users]="this.state.users$"
        [showAllEntry]="false"
        [multiple]="true"
        (selectedUserChanged)="userChange($event)"
      ></lib-user-picker>
      <lib-user-picker
        [disabled]="workDayId != null"
        *ngIf="workDayId"
        [users]="this.state.users$"
        [showAllEntry]="false"
        (selectedUserChanged)="userChange($event)"
        [preselectedUsers]="newWorkDay.user"
      ></lib-user-picker>
    </div>

    <div class="select-form wide">
      <div>Arbeitsdatum</div>
      <div>Arbeitszeit gesamt</div>
    </div>
    <div class="select-form wide">
      <lib-date-time-picker
        [type]="'date'"
        [disabled]="isAnyApproved()"
        [inputDateZulu]="newWorkDay.workingDate"
        (selectedDateChanged)="workDayDateChanged($event)"
      ></lib-date-time-picker>
      <div>{{ fullDayWorked }}</div>
    </div>

    <div
      class="existing-workdays danger wide"
      *ngFor="let usr of usersWithExistingWorkDays"
    >
      Für {{ state.getUserDisplayNameAsync(usr) | async }} gibt es bereits
      Arbeitsstunden für dieses Datum!
    </div>
    @if(usersWithExistingWorkDays?.length != 1){
    <h4>Baustellen:</h4>
    <div
      *ngFor="let workEntry of this.newWorkDay.workEntries; let i = index"
      class="work-entry"
    >
      <div
        *ngIf="workEntry.approvedBy != null && this.workDayId"
        style="padding: 5px"
      >
        <div class="stretch" style="font-weight: 500">
          <div>
            {{ state.getConstructionSiteName(workEntry.constructionSite) }}
          </div>
          <div>
            {{ workEntry.durationInHours }}H {{ workEntry.durationInMins }}M
          </div>
        </div>

        <div
          class="stretch"
          *ngIf="workEntry?.description && workEntry.description != ''"
        >
          <div>Beschreibung:</div>
          <div style="padding-left: 10px">{{ workEntry.description }}</div>
        </div>

        <!--div>Arbeitszeiten:</div-->
        <div class="stretch">
          <div>Startzeit</div>

          <div>Endzeit</div>
        </div>

        <div
          class="stretch"
          *ngFor="let entry of workEntry.timeEntries; let i = index"
        >
          <div>{{ tools.formatTime(entry.start) }}</div>
          <div>-</div>
          <div>{{ tools.formatTime(entry.end) }}</div>
        </div>

        <div class="centered" *ngIf="workEntry.approvedBy">
          Status: Bestätigt
          <ion-icon
            style="color: rgb(0, 179, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
        </div>
      </div>
      <div *ngIf="workEntry.approvedBy == null || this.workDayId == null">
        <div class="select-form-flex">
          <lib-construction-site-picker
            style="width: 100%"
            [conSites]="state.conSites$"
            [preselectedConSite]="workEntry.constructionSite"
            [showAllEntry]="false"
            [blackList]="getSelectedConSiteIds()"
            (selectedConSiteChanged)="conSiteChange($event, workEntry)"
          ></lib-construction-site-picker>
          <ion-icon
            style="font-size: 30px; margin: 0 0 0 20px"
            (click)="removeConSite(workEntry)"
            name="trash-outline"
          ></ion-icon>
        </div>
        <div class="select-form">
          <ion-textarea
            label="Beschreibung"
            labelPlacement="floating"
            fill="outline"
            mode="md"
            [(ngModel)]="workEntry.description"
            placeholder="Beschreibung hinzufügen.."
          ></ion-textarea>
        </div>
        <div class="wide select-form">
          <div>Arbeitszeit</div>
          <div>{{ this.tools.calculateHours(workEntry.timeEntries) }}</div>
        </div>
        <div class="wide select-form">
          <div>Startzeit</div>
          <div></div>
          <div>Endzeit</div>
          <div></div>
        </div>

        <div
          class="wide"
          style="margin: 10px 10px"
          *ngFor="let entry of workEntry.timeEntries; let i = index"
        >
          <!--input type="time" [(ngModel)]="entry.start" /-->
          <lib-date-time-picker
            [type]="'time'"
            [inputDateZulu]="entry.start"
            (selectedDateChanged)="timeEntryStartChanged(entry, $event)"
          ></lib-date-time-picker>
          <span>-</span>
          <!--input type="time" [(ngModel)]="entry.end" /-->
          <lib-date-time-picker
            [type]="'time'"
            [inputDateZulu]="entry.end"
            [hourDelay]="1"
            (selectedDateChanged)="timeEntryEndChanged(entry, $event)"
          ></lib-date-time-picker>
          <ion-icon
            style="font-size: 22px"
            (click)="removeTimeEntry(workEntry.timeEntries, i)"
            name="trash-outline"
          ></ion-icon>
        </div>
        <div
          *ngIf="tools.timeEntriesInvalid(workEntry.timeEntries)"
          class="time-entry-error danger"
        >
          Endzeit muss nach der Startzeit liegen
        </div>
        <div style="display: flex; justify-content: center">
          <ion-icon
            (click)="addTimeEntry(workEntry)"
            name="add-outline"
          ></ion-icon>
        </div>
      </div>
    </div>

    <div style="display: flex; justify-content: center">
      <!--ion-icon (click)="addWorkEntry()" name="add-outline"></ion-icon-->
      <ion-button (click)="addWorkEntry()"
        >Weitere Baustelle hinzufügen</ion-button
      >
    </div>
    }
    <!--div style="margin-bottom: 10px">
      <ion-button
        style="width: 100%"
        (click)="createTimeEntry()"
        [disabled]="!inputsValid()"
        *ngIf="!workDayId"
        >Arbeitszeit anlegen</ion-button
      >
      <ion-button
        style="width: 100%"
        (click)="updateTimeEntry()"
        [disabled]="!inputsValid()"
        *ngIf="workDayId"
        >Arbeitszeit aktualisieren</ion-button
      >
    </div-->
  </div>
</ion-content>
